<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    toolTip: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="flex min-w-[10rem] flex-col items-start justify-center gap-2">
    <span
      class="inline-flex items-center gap-1 text-xs font-medium uppercase tracking-[0.08em] text-auth-muted dark:text-auth-muted-dark"
    >
      {{ label }}
      <fluent-icon
        v-tooltip.right="toolTip"
        size="14"
        icon="information"
        type="outline"
        class="flex flex-shrink-0 text-sm font-normal text-auth-muted dark:text-auth-muted-dark sm:font-medium"
      />
    </span>
    <div
      v-if="isLoading"
      class="mb-0.5 h-6 w-12 animate-pulse rounded-md bg-auth-border dark:bg-auth-border-dark"
    />

    <span
      v-else
      class="text-2xl font-semibold tabular-nums tracking-[-0.025em] text-auth-text dark:text-auth-text-dark"
    >
      {{ value }}
    </span>
  </div>
</template>
